const templateUrl = require('./toast-container.html');

module.exports = {
  templateUrl: templateUrl,
  controller: require('./toast-container.controller')
};
